export default {
    VIDEO: 'x-zattoo/video',
};
